import {notification} from 'antd';
import React, {createContext, useContext} from 'react';

import {AppContextProps} from './AppContext';

type NotificationType = 'success' | 'info' | 'warning' | 'error';

interface NotificationContextType {
    openNotificationWithIcon: (type: NotificationType, title: React.ReactNode, description?: React.ReactNode) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<AppContextProps> = ({children}) => {
    const [api, contextHolder] = notification.useNotification();

    const openNotificationWithIcon = (
        type: NotificationType,
        title: React.ReactNode,
        description?: React.ReactNode
    ) => {
        api[type]({
            message: title,
            description: description,
        });
    };

    return (
        <NotificationContext.Provider value={{openNotificationWithIcon}}>
            {contextHolder}
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (context === undefined) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};
